//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import conditionItem from "@/components/Diagrams/config/subcomponents/condition-item.vue";
import { evBus } from "../set-conditions";

export default {
    name: "NestedDraggable",
    components: {
        draggable,
        conditionItem
    },
    props: {
        isNested: {
            required: false,
            type: Boolean,
            default: false
        },
        isReadOnly: {
            required: false,
            type: Boolean,
            default: false
        },
        fromRepeatable: {
            type: Boolean,
            default: false
        },
        itemReference: {
            type: Object,
            required: true,
            default() {
                return {
                    type: "group",
                    logicOperatorAfter: null,
                    conditions: []
                };
            }
        },
        itemReferenceIndex: {
            type: Number,
            default: null
        },
        breadcrumbs: {
            type: String,
            default: ""
        },
        itemsResults: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            logicOperators: {
                "&&": "AND",
                "||": "OR"
            }
        };
    },
    computed: {
        logicOperatorLabel() {
            return this.logicOperators[this.itemReference.logicOperatorAfter];
        }
    },
    watch: {},
    methods: {
        getEvaluationClass(index) {
            try {
                return this.itemsResults[index].result;
            } catch (e) {
                return "";
            }
        },
        optionalProps(index) {
            const props = {};
            try {
                props.itemsResults = this.itemsResults[index].conditions;
            } catch (err) {
                // continue regardless of error
            }
            return props;
        },
        addBreadcrumbs(index) {
            return this.breadcrumbs
                ? `${this.breadcrumbs}.${index + 1}`
                : `${index + 1}`;
        },
        deleteItem(index) {
            // eslint-disable-next-line vue/no-mutating-props
            this.itemReference.conditions.splice(index, 1);
            this.refresh();
        },
        refresh() {
            evBus.$emit("refresh");
        },
        showEvaluation(type) {
            return type === "group" || this.isReadOnly;
        }
    }
};
